module.exports = __webpack_public_path__ + "img/MTM2729-19S-彩福尖子-LOGO.83feab3d.png";